import { Grid, Typography } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from 'src/common/emerald-modal-manager/emerald-modal-manager';
import { ProductDisplayView } from 'src/common/enumerations/product-display-view';
import XLRLogger from 'src/common/helpers/logger';
import { ISelectedItem } from 'src/common/interfaces/dtos/ISelectedItem';
import { trainingModeStyles } from 'src/common/training-mode/training-mode-styles';
import ProductDisplayLayoutWrapper from 'src/product-display-layout/components/product-display-layout-wrapper';
import DoubleTrainingModeWatermark from 'src/common/training-mode/double-training-mode-watermark';
import { styles } from './all-items-styles';
import EmeraldModal from '../common/components/emerald-modal/emerald-modal';
import { useTranslation } from 'react-i18next';
import { onScanned } from 'src/bottom-area/business-logic/handle-plu-items';

const ALL_ITEM_MODAL = 'ALL_ITEM_MODAL';
export const showAllItems = (props: IAllItemsProps): void => {
  pushEmeraldModal(<AllItems {...props} />, onScanned, ALL_ITEM_MODAL);
};
export const closeAllItems = (): void => {
  popEmeraldModal(ALL_ITEM_MODAL);
};

const AllItems = ({
  onProductSelected,
  onFinish,
  onKeypadSubmit,
  pluTabValue,
  trainingModeActive,
}: IAllItemsProps): JSX.Element => {
  const classes = styles();
  const trainingModeclasses = trainingModeStyles();
  const { t } = useTranslation();

  const [display, setDisplay] = useState<ProductDisplayView>(ProductDisplayView.Grid);
  const [cardDisplayAvailable, setCardDisplayAvailable] = useState<boolean>(true);
  const [productDisplaySize, setProductDisplaySize] = useState<number>(0);

  const resizeHandler = useCallback((): void => {
    if (window.screen.availWidth <= 1024) {
      setCardDisplayAvailable(false);
      setDisplay(ProductDisplayView.Grid);
    } else if (!cardDisplayAvailable) {
      setCardDisplayAvailable(true);
    }
  }, [cardDisplayAvailable]);

  useEffect(() => {
    resizeHandler();
    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, [resizeHandler]);

  useEffect((): void => {
    setProductDisplaySize(12);
    XLRLogger.debug({
      message: 'All Items View Visible',
      source: 'all-items.tsx',
    });
  }, []);

  return (
    <EmeraldModal open data-testid='all-items-modal' disablePortal={true}>
      <Grid
        container
        direction='column'
        className={`${classes.main} ${
          trainingModeActive ? trainingModeclasses.trainingModeBackground : classes.background
        }`}
      >
        {trainingModeActive && <DoubleTrainingModeWatermark />}
        <Grid item className={`${classes.topArea} fullWidth`}>
          <Grid container className={`fullHeight`}>
            <Grid item xs={6} className={classes.productLabel}>
              <Typography variant='h2'>{t('Products')}</Typography>
              <Grid item className={classes.productDivider} />
            </Grid>
          </Grid>
        </Grid>
        <Grid container direction='row' className={`${classes.allItemsWrapper} fullWidth`}>
          <Grid item className={`${classes.allItemsMiddleArea}`}>
            <ProductDisplayLayoutWrapper
              displayView={display}
              displaySize={productDisplaySize}
              onProductSelected={onProductSelected}
              onFinish={onFinish}
              onKeypadSubmit={onKeypadSubmit}
              pluTabValue={pluTabValue || 0}
            />
          </Grid>
        </Grid>
      </Grid>
    </EmeraldModal>
  );
};

export interface IAllItemsProps {
  onProductSelected: (selectedItem: ISelectedItem) => Promise<void>;
  onFinish: () => void;
  onKeypadSubmit: (input: string) => Promise<void>;
  pluTabValue?: number;
  trainingModeActive: boolean;
}

export default AllItems;
